import PropTypes from 'prop-types'
import { format } from 'date-fns-tz'
import { useTranslation } from 'react-i18next'

import { dayMinutesToHoursMinutes } from '../../../helpers/helpers'
import { getAssetLink } from '../../../helpers/get-asset-link'

const BookingBox = ({ booking, onClick, selectedBooking, timezone }) => {
  const { t } = useTranslation(['client-reservations'])
  const { name, image } = booking.amenityId
  const { cancelled, cancelledBy, approved } = booking

  const currentDate = new Date()
  const endDate = booking.endDate ? new Date(booking.endDate) : null
  const bookingDate = new Date(booking.date)
  bookingDate.setMinutes(booking.endTime)

  const timezonedDate = booking.date
  const timezonedEnddate = booking.endDate ? booking.endDate : 0

  const bookingDetails = booking.amenityId.multiDayBooking
    ? `${format(timezonedDate, 'MMMM', {
        timeZone: timezone,
      })} ${format(timezonedDate, 'dd', { timeZone: timezone })} - ${format(
        timezonedEnddate,
        'MMMM',
        {
          timeZone: timezone,
        },
      )} ${format(timezonedEnddate, 'dd', { timeZone: timezone })}`
    : `${format(timezonedDate, 'MMMM', {
        timeZone: timezone,
      })} ${format(timezonedDate, 'dd', { timeZone: timezone })} | ${dayMinutesToHoursMinutes(
        booking.startTime,
      )} - ${dayMinutesToHoursMinutes(booking.endTime)}`

  const shouldRender =
    booking.amenityId.multiDayBooking && endDate
      ? endDate.getTime() >= currentDate.getTime()
      : bookingDate.getTime() > currentDate.getTime()

  return shouldRender ? (
    <div
      className="booking-box"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0,
          ${selectedBooking && selectedBooking.id === booking.id ? '0.2' : '0.6'}),
          rgba(0, 0, 0, ${selectedBooking && selectedBooking.id === booking.id ? '0.2' : '0.6'})),
          url(${getAssetLink({ path: 'chitown-building', file: image })})`,
      }}
      onClick={() => onClick(booking)}
    >
      <div className="booking-title">{name}</div>
      <div className="booking-date">{bookingDetails}</div>
      <div
        className="booking-status-container"
        style={
          cancelled
            ? { backgroundColor: '#8C8C8C' }
            : approved
              ? { backgroundColor: '#52C41A' }
              : { backgroundColor: '#FF704C' }
        }
      >
        <div className="booking-status-details">
          {!cancelled
            ? approved
              ? t('client-reservations:bookingBox.confirmed')
              : t('client-reservations:bookingBox.pendingApproval')
            : cancelledBy &&
                ['ShiftManager', 'PropertyManager', 'Administrator'].includes(cancelledBy)
              ? t('client-reservations:bookingBox.cancelledByManagement')
              : t('client-reservations:bookingBox.cancelled')}
        </div>
      </div>
    </div>
  ) : null
}

BookingBox.propTypes = {
  booking: PropTypes.object,
  onClick: PropTypes.func,
  selectedBooking: PropTypes.object,
  timezone: PropTypes.string,
}

export default BookingBox
